import React from "react";
import { createRoot } from "react-dom/client";
import Header from "../components/Header/Header";

const renderHeader = ($) => {
	const HeaderContainer = $("#js-header")[0];
	if (!HeaderContainer) return;

	let props = {
		...HeaderContainer.dataset,
	};

	const root = createRoot(HeaderContainer);
	root.render(<Header {...props} />);
};

export default renderHeader;
